(function(){
  if (window.__cubInstallModalInit) return;
  window.__cubInstallModalInit = true;

  var overlay  = document.getElementById('cl-install-overlay');
  var productEl = document.getElementById('cl-install-product');
  var optionsEl = document.getElementById('cl-install-options');
  var atcBtn    = document.getElementById('cl-install-atc');
  var labelEl   = document.getElementById('cl-install-label');
  var closeBtn  = document.getElementById('cl-install-close');

  if (!overlay) return;

  var selectedVariantId = null;
  var isAddonFlow = false;
  var currentMainVariantId = null;

  function openModal() {
    overlay.classList.add('open');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeModal() {
    overlay.classList.remove('open');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    atcBtn.disabled = false;
    atcBtn.textContent = 'Add to Cart';
  }
  closeBtn.addEventListener('click', closeModal);
  overlay.addEventListener('click', function(e){ if (e.target === overlay) closeModal(); });
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && overlay.classList.contains('open')) closeModal(); });

  function selectInGroup(groupName, optEl, variantId) {
    /* Clear other selections in same group */
    optionsEl.querySelectorAll('.cl-install-opt[data-group="' + CSS.escape(groupName) + '"]').forEach(function(o){
      o.classList.remove('selected');
    });
    optEl.classList.add('selected');
    window.__cubModalSelections[groupName] = variantId ? String(variantId) : '';
  }

  function buildOption(v, i, label, sub, priceLabel) {
    var opt = document.createElement('div');
    opt.className = 'cl-install-opt' + (i === 0 ? ' selected' : '');
    opt.setAttribute('data-variant-id', v.id);
    opt.innerHTML =
      '<div class="cl-install-radio"></div>' +
      '<div class="cl-install-opt-text"><strong>' + label + '</strong>' + (sub ? '<span>' + sub + '</span>' : '') + '</div>' +
      '<div class="cl-install-opt-price">' + priceLabel + '</div>';
    opt.addEventListener('click', function(){
      optionsEl.querySelectorAll('.cl-install-opt').forEach(function(o){ o.classList.remove('selected'); });
      opt.classList.add('selected');
      selectedVariantId = v.id;
    });
    return opt;
  }

  function openForCard(card) {
    var variants = [];
    var addons   = [];
    try { variants = JSON.parse(card.getAttribute('data-product-variants') || '[]'); } catch(e){}
    try { addons   = JSON.parse(card.getAttribute('data-product-addons')   || '[]'); } catch(e){}
    var mainVariantId = card.getAttribute('data-product-variant-id');
    var title  = card.getAttribute('data-product-title')  || '';
    var colour = card.getAttribute('data-product-colour') || '';
    var price  = card.getAttribute('data-product-price')  || '';
    var image  = card.getAttribute('data-product-image')  || '';

    productEl.innerHTML =
      (image ? '<img class="cl-install-thumb" src="' + image + '" alt="' + title + '">' : '') +
      '<div class="cl-install-product-info">' +
        '<h3>' + title + '</h3>' +
        (colour ? '<div class="cl-install-colour">' + colour + '</div>' : '') +
        '<div class="cl-install-price">' + price + '</div>' +
      '</div>';

    /* Addon flow: group variants by parent addon product (addon_name) and
       render one radio section per group, matching the PDP's separate
       dropdowns. Each group has a "No thanks" default option so the user
       can skip optional addons. Submit collects all non-skipped picks. */
    if (addons.length > 0) {
      optionsEl.innerHTML = '';
      currentMainVariantId = mainVariantId;
      isAddonFlow = true;
      labelEl.textContent = ''; /* Use per-group labels instead */

      /* Group variants by addon_name, preserving order */
      var groups = [];
      var groupMap = {};
      addons.forEach(function(v) {
        var name = v.addon_name || 'Add-on';
        if (!groupMap[name]) {
          groupMap[name] = { name: name, variants: [] };
          groups.push(groupMap[name]);
        }
        groupMap[name].variants.push(v);
      });

      /* Track selection per group on the wrapper so submit can read them */
      optionsEl.dataset.groupCount = groups.length;
      window.__cubModalGroups = groups;
      window.__cubModalSelections = {}; /* groupName → variantId or '' */

      groups.forEach(function(group, gi) {
        /* Group header */
        var header = document.createElement('div');
        header.className = 'cl-install-group-label';
        header.textContent = group.name;
        optionsEl.appendChild(header);

        /* "No thanks" first option */
        var none = document.createElement('div');
        none.className = 'cl-install-opt cl-install-opt--none selected';
        none.dataset.group = group.name;
        none.dataset.variantId = '';
        none.innerHTML =
          '<div class="cl-install-radio"></div>' +
          '<div class="cl-install-opt-text"><strong>No thanks</strong></div>' +
          '<div class="cl-install-opt-price"></div>';
        none.addEventListener('click', function(){ selectInGroup(group.name, none, ''); });
        optionsEl.appendChild(none);
        window.__cubModalSelections[group.name] = '';

        /* Render addon variants for this group */
        group.variants.forEach(function(v, vi) {
          var t = (v.title || v.option1 || '').toString();
          var tl = t.toLowerCase();
          var label = (tl === 'default title' || tl === '-' || !t) ? group.name : t;
          var priceLabel = (v.price === 0) ? 'Included' : '+$' + Math.round(v.price/100);

          var opt = document.createElement('div');
          opt.className = 'cl-install-opt';
          opt.dataset.group = group.name;
          opt.dataset.variantId = v.id;
          opt.innerHTML =
            '<div class="cl-install-radio"></div>' +
            '<div class="cl-install-opt-text"><strong>' + label + '</strong></div>' +
            '<div class="cl-install-opt-price">' + priceLabel + '</div>';
          opt.addEventListener('click', function(){ selectInGroup(group.name, opt, v.id); });
          optionsEl.appendChild(opt);
        });
      });
      openModal();
      return;
    }

    /* Multi-variant: show option picker */
    if (variants.length > 1) {
      labelEl.textContent = 'Select Option';
      optionsEl.innerHTML = '';
      selectedVariantId = null;
      isAddonFlow = false;
      currentMainVariantId = null;

      variants.forEach(function(v, i){
        var label = v.title || v.option1 || '';
        var priceLabel = v.price_fmt || ('$' + (v.price/100).toFixed(0));
        optionsEl.appendChild(buildOption(v, i, label, '', priceLabel));
        if (i === 0) selectedVariantId = v.id;
      });
      openModal();
      return;
    }

    /* Single variant — add directly */
    selectedVariantId = variants[0] ? variants[0].id : (mainVariantId || null);
    isAddonFlow = false;
    addToCart(/*direct*/ true);
  }

  function addToCart(direct) {
    if (!direct) { atcBtn.disabled = true; atcBtn.textContent = 'Adding…'; }

    var items = [];

    if (isAddonFlow && currentMainVariantId) {
      /* Main product first */
      items.push({ id: parseInt(currentMainVariantId, 10), quantity: 1 });
      /* Then every selected addon (skipping groups where user chose "No thanks") */
      var selections = window.__cubModalSelections || {};
      Object.keys(selections).forEach(function(group){
        var id = selections[group];
        if (id) items.push({ id: parseInt(id, 10), quantity: 1 });
      });
    } else if (selectedVariantId) {
      items.push({ id: parseInt(selectedVariantId, 10), quantity: 1 });
    } else {
      atcBtn.disabled = false;
      atcBtn.textContent = 'Add to Cart';
      return;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
      body: JSON.stringify({ items: items }),
    })
    .then(function(r){ return r.json(); })
    .then(function(){
      /* Fetch cart for downstream listeners (Upnova/Klaviyo) */
      return fetch('/cart.js').then(function(r){ return r.json(); });
    })
    .then(function(cart){
      /* Dispatch cart:update so cart drawer (Upnova) refreshes */
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: { resource: cart, sourceId: 'cl-install-modal', data: { source: 'cl-install-modal' } },
      }));
      /* Open cart drawer if present */
      var drawer = document.querySelector('cart-drawer, [is="cart-drawer"], upnova-widget[model="cart-drawer"]');
      if (drawer) {
        if (typeof drawer.open === 'function') drawer.open();
        else if (typeof drawer.show === 'function') drawer.show();
      }
      closeModal();
    })
    .catch(function(err){
      console.error('[cl-install-modal] add to cart failed', err);
      atcBtn.disabled = false;
      atcBtn.textContent = 'Add to Cart';
    });
  }

  atcBtn.addEventListener('click', function(){ addToCart(false); });

  /* Delegate click on any [data-cl-open-install] across the page */
  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-cl-open-install]');
    if (!btn) return;
    e.preventDefault();
    var card = btn.closest('[data-cl-card]');
    if (!card) return;
    openForCard(card);
  });
})();